// import { getCookie } from '../cookies';

import { DEFAULT_LTV } from '../../../server/quiz.calculateLtv';

/**
 * @typedef {object} tikTokEventApiAffiliateInfo
 * @property {string} event - event name that matches TikTok (in this case CompletePayment)
 * @property {string} event_id - id used for deduplication on TikTok's end
 * @property {number} event_time - current timestamp
 * @property {string} timestamp - current timestamp to ISO string
 * @property {object} user - contains hashed user info
 * @property {object} properties - contains order information
 */

/**
 *
 * @param {string|number} orderId - the order id
 * @returns {tikTokEventApiAffiliateInfo}
 */
export function tikTokEventApiAffiliateInfo(orderId) {
  const predicted_ltv = dataLayer.find((x) => x?.ltv)?.ltv;
  const hashedEmail = dataLayer.find((x) => x?.hashedEmail)?.hashedEmail;
  const ttclid = dataLayer.find((x) => x?.ttclid)?.ttclid || '';
  const externalId = dataLayer.find((x) => x?.rid)?.rid || '';

  const userAgent = navigator.userAgent;
  const locale = navigator.language;

  // eslint-disable-next-line
  let url = globalThis?.location.href;

  return {
    event: 'CompletePayment',
    event_id: orderId.toString(),
    event_time: Date.now(),
    timestamp: new Date().toISOstring,
    user: {
      ttclid: ttclid || '',
      email: hashedEmail,
      external_id: externalId,
      user_agent: userAgent,
      locale,
      ip: '',
    },
    properties: {
      contents: [
        {
          brand: 'WayBetter',
          content_category: 'Membership',
          content_id: '22',
          content_name: 'WayBetter Trial Signup',
        },
      ],
      currency: 'USD',
      value: predicted_ltv || DEFAULT_LTV,
      order_id: orderId.toString(),
    },
    page: {
      url,
    },
    limited_data_use: false,
  };
}
